import get from 'transmute/get';
export const getInitialMessageBubbleVisible = get('initialMessageBubbleVisible');